// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3Zdx0","rootCenter":"LoadMoreObserver_rootCenter__3l7fy","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1CQ5j"};